/* -------------------------------------------------------------------------------------
Vuex module to manage track data

Main components
---------------
mutations:
- SET_TRACKS_KML_LOADING: Sets KML loading status
- SET_TRACKS_KML: Sets URL where the tracks KML file to be displayed is located

actions:
- getTracksKmlFiltered: Gets KML file for user specific tracks to be displayed on map
- getTracksKmlInitial: Gets the initial KML load upon opening of the site

states concerned:
- state.tracksKmlIsLoading
- state.url
- state.center
- state.tracksExtentMin
- state.tracksExtentMax

---------------------------------------------------------------------------------------*/

// import tourdb library
import ApiService from '@/services/ApiService.js'

export const namespaced = true

export const state = {
  tracksKmlIsLoading: false,
  url: '',
  center: [],
  tracksExtentMin: [],
  tracksExtentMax: [],
  format: '',
  geoJsonObject: {},
}

export const mutations = {

  // Set KML loading status
  SET_TRACKS_KML_LOADING(state, isLoading) {
    state.tracksKmlIsLoading = isLoading
  },

  // Set URL where the tracks KML file to be displayed is located
  SET_TRACKS_KML(state, tracksKml) { // --> rename 
    state.url = tracksKml.url
    state.center = tracksKml.center
    state.tracksExtentMin = tracksKml.tracksExtentMin
    state.tracksExtentMax = tracksKml.tracksExtentMax
    state.format = tracksKml.format
    state.geoJsonObject = tracksKml.geoJsonObject
    //state.geoJsonObject = JSON.parse(JSON.stringify(tracksKml.geoJsonObject))
  }
}

export const actions = {

  // triggered when user requests specific tracks to be displayed on map
  getTracksKmlFiltered({ commit, dispatch }, params ) {
    

    // First set state field to loading = true
    commit('SET_TRACKS_KML_LOADING', true) 

    // Then request the KML file for the selected track IDs (file is generated by server and stored there - only the file URL is returned) 
    if (params.trackIds.length > 0) {
      ApiService.getTracksKmlFiltered(params.trackIds, params.format)
        .then(response => {
          
          // write track KML URL and center coordinates to state
          commit('SET_TRACKS_KML', {
            url: response.data.tracksKml.tracksKmlUrl,
            center: response.data.tracksKml.center,
            tracksExtentMin: response.data.tracksKml.tracksExtentMin,
            tracksExtentMax: response.data.tracksKml.tracksExtentMax,
            format: params.format,
            geoJsonObject: response.data.tracksKml.geoJsonObject,
          })
        })

        // Error handling
        .catch(error => {
          const notification = {
            type: 'error',
            message:
              'There was an error generating the tracks kml: ' + error.message
          }
          dispatch('notification/add', notification, { root: true })
        })

        // set state field to loading to false
        commit('SET_TRACKS_KML_LOADING', false) 

    // If no trackIDs are delivered an error is returned    
    } else {
      const notification = {
        type: 'error',
        message: 'No matching track found!'
      }
      dispatch('notification/add', notification, { root: true })
    }
  },

  // Initial KML load upon opening of the site
  getTracksKmlInitial({ commit, dispatch }, params) {
    
    // First set state field to loading = true
    commit('SET_TRACKS_KML_LOADING', true) 

    // Then request initial KML file from server (file is generated by server and stored there - only the file URL is returned)
    ApiService.getTracksKmlInitial(params)

      // Process success
      .then(response => {

        // write track KML URL and center coordinates to state
        commit('SET_TRACKS_KML', {
          url: response.data.tracksKml.tracksKmlUrl,
          center: response.data.tracksKml.center,
          tracksExtentMin: response.data.tracksKml.tracksExtentMin,
          tracksExtentMax: response.data.tracksKml.tracksExtentMax,
          format: params.format,
          geoJsonObject: response.data.tracksKml.geoJsonObject,
        })
        
      })

      // Error handling
      .catch(error => {
        const notification = {
          type: 'error',
          message:
            'There was an error generating the tracks kml: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })

      // Set loading status to false
      commit('SET_TRACKS_KML_LOADING', false)
  }
}
